import * as S from './styled';

interface Props {
  children: any;
  customStyles?: string;
}

export const AILabel = ({ children, customStyles = '' }: Props) => (
  <S.Label $customStyles={customStyles}>{children}</S.Label>
);
